webpackJsonp([263791100135453],{

/***/ 321:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(19);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(321);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPage = function AboutPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: 'about-page' },
	    _react2.default.createElement(
	      'div',
	      { className: 'about-header' },
	      'about me'
	    ),
	    _react2.default.createElement(_gatsbyImage2.default, { className: 'about-profile-picture', resolutions: data.allFile.edges[0].node.childImageSharp.resolutions }),
	    _react2.default.createElement(
	      'p',
	      { className: 'about-intro' },
	      'Hi! I\'m Sarah B. '
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'about-blurb' },
	      'I\'m a Durham based artist, designer, social media expert, and lover of Jesus. I\'m moving to D.C. soon to pursue my art career. I am always available for hire for one time projects or full time work. If you like my work, please ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/contact' },
	        'contact me!'
	      )
	    )
	  );
	};
	
	exports.default = AboutPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-917c151646921f74b22e.js